export default "__VITE_ASSET__F7RtgvQC__"